import { createContext, useContext } from 'react';
export var PictureInPictureContext = /*#__PURE__*/createContext(undefined);
export var usePictureInPictureContext = function usePictureInPictureContext() {
  var context = useContext(PictureInPictureContext);
  if (context === undefined) {
    throw new Error('usePictureInPictureContext must be used within a PictureInPictureProvider component');
  }
  return context;
};